import api from './Api'

const route = '/auth'

export default {
  login: credentials => api().post(`${route}/login`, credentials),
  signup: userDetails => api().post(`${route}/signup`, userDetails),
  switchSession: email => api().post(`${route}/session/switch`, email),
  // El Administrador de Grupo sale del dealer en el que había entrado
  exitDealer: () => api().post(`${route}/exit-dealer`),
  // El Super Admin entra en un grupo como gestor y vuelve a su sesión
  enterGrupo: grupoId => api().post(`${route}/enter-grupo`, { grupo_id: grupoId }),
  exitGrupo: () => api().post(`${route}/exit-grupo`)

}
